$(function(){
    // focus fix for modal inputs
        let pageScroll = 0; 
        $(".modal").on('show.bs.modal', () => {
        // when modal is opened, go to top of page
        pageScroll = $(window).scrollTop();
            window.scroll({
                top: 0
            }); 
        });
        $(".modal").on('hide.bs.modal', () => {
            // when it's closed, return back
            window.scroll({
                top: pageScroll
            });
        });
    // --- focus fix for modal inputs ---
});